<template>
  <h1>CLIENTS LIST</h1>
</template>

<script>
export default {};
</script>
